import React, {useState, useEffect} from "react";
import CustomSelect from "../customSelect/CustomSelect";
import { getSchools, getStudents } from "../../services/scpApi";
import { yearGroups } from "../../data/data";
import { useDispatch, useSelector } from "react-redux";
import { fetchStudent } from "../../slices/portalSelectedSlice";
import { clearSelectedStudent, setSelectedSchool, setSelectedStudent, setSelectedYearGroup } from "../../slices/portalSelectedSlice";


const SelectStudent = () => {

    const [schools, setSchools] = useState([]);
    const [students, setStudents] = useState([]);

    const dispatch = useDispatch();
    const selectedStudent = useSelector(state => state.portalSelected.selectedStudent);
    const selectedSchool = useSelector(state => state.portalSelected.selectedSchool);
    const selectedYearGroup = useSelector(state => state.portalSelected.selectedYearGroup);

    // get schools
    useEffect(() => {
        (async () => {
            try {
                const response = await getSchools();
                setSchools(response);
            } catch (error) {
                console.log(error);
            }
        })();
    }, [])

    // get students
    useEffect(() => {
        if (selectedSchool?.id && selectedYearGroup?.year) {
            (async () => {
                try {
                    let students = await getStudents({
                        schoolId: selectedSchool.id,
                        yearGroup: selectedYearGroup.year
                    });
    
                    students = students.sort((a, b) => a.name.localeCompare(b.name));
                    setStudents(students);
    
                    // If current student is not in the fetched list, clear it
                    const stillValid = students.find(s => s.id === selectedStudent?.id);
                    if (!stillValid) {
                        dispatch(clearSelectedStudent());
                    }
    
                } catch (error) {
                    console.log(error);
                }
            })();
        } else {
            dispatch(clearSelectedStudent()); 
        }
    }, [selectedSchool, selectedYearGroup]);
    
    const handleSelectStudent = (student) => {
        if (student) {
            dispatch(fetchStudent(student.id));
        }
    }

    return (
        <div className="flex-row-select-cont">

            <CustomSelect
                name="select-school" 
                placeholder="Select School"
                options={schools}
                labelKey="name"
                setSelectedOption={(option) => dispatch(setSelectedSchool(option))}
                selectedOption={selectedSchool}
            />

            <CustomSelect
                name="select-year-group" 
                placeholder="Select Year Group"
                options={yearGroups}
                labelKey="name"
                setSelectedOption={(option) => dispatch(setSelectedYearGroup(option))}
                selectedOption={selectedYearGroup}
            />

            <CustomSelect
                name="select-student" 
                placeholder="Select Student"
                options={students}
                labelKey="name"
                setSelectedOption={(option) => handleSelectStudent(option)}
                selectedOption={selectedStudent}
            />
        </div>
    );
}

export default SelectStudent;